import { createSlice } from "@reduxjs/toolkit";

const gameSlice = createSlice({
  name: "game",
  initialState: {
    id: "",
    genre: [],
    subject: [],
    theme: [],
    category: "",
    fullname: "",
    wasStarted: false,
    wasCompleted: false,
    wasLevelStarted: false,
    isPaused: false,
    gameActiveStartTime: null,
    levelTime: {},
    gameTotalDuration: 0,
    levelTotalDuration: {},
    gameHasCompletionState: false,
    gamePageCurrentURL: "",
  },
  reducers: {
    setId: (prevState, action) => {
      const state = prevState;
      state.id = action.payload.id;
    },
    setGenre: (prevState, action) => {
      const state = prevState;
      state.genre = action.payload.genre;
    },
    setSubject: (prevState, action) => {
      const state = prevState;
      state.subject = action.payload.subject;
    },
    setTheme: (prevState, action) => {
      const state = prevState;
      state.theme = action.payload.theme;
    },
    setCategory: (prevState, action) => {
      const state = prevState;
      state.category = action.payload.category;
    },
    setFullname: (prevState, action) => {
      const state = prevState;
      state.fullname = action.payload.fullname;
    },
    setWasStarted: (prevState, action) => {
      const state = prevState;
      state.wasStarted = action.payload.wasStarted;
    },
    setWasCompleted: (prevState, action) => {
      const state = prevState;
      state.wasCompleted = action.payload.wasCompleted;
    },
    setWasLevelStarted: (prevState, action) => {
      const state = prevState;
      state.wasLevelStarted = action.payload.wasLevelStarted;
    },
    setIsPaused: (prevState, action) => {
      const state = prevState;
      state.isPaused = action.payload.isPaused;
    },
    setGameActiveStartTime: (prevState, action) => {
      const state = prevState;
      state.gameActiveStartTime = action.payload.gameActiveStartTime;
    },
    setLevelTime: (prevState, action) => {
      const state = prevState;
      state.levelTime = { ...state.levelTime, [action.payload.level]: action.payload.levelTime };
    },
    setGameTotalDuration: (prevState, action) => {
      const state = prevState;
      state.gameTotalDuration = action.payload.gameTotalDuration;
    },
    setLevelTotalDuration: (prevState, action) => {
      const state = prevState;
      state.levelTotalDuration = {
        ...state.levelTotalDuration,
        [action.payload.level]: action.payload.levelTotalDuration,
      };
    },
    setGameHasCompletionState: (prevState, action) => {
      const state = prevState;
      state.gameHasCompletionState = !!action.payload.gameHasCompletionState;
    },
    setGamePageCurrentURL: (prevState, action) => {
      const state = prevState;
      state.gamePageCurrentURL = action.payload.gamePageCurrentURL;
    },
    setGame: (prevState, action) => {
      const state = prevState;
      const { id, genre, subject, theme, category, fullname, gamePageCurrentURL } = action.payload;
      state.id = id;
      state.genre = genre;
      state.subject = subject;
      state.theme = theme;
      state.category = category;
      state.fullname = fullname;
      state.wasStarted = false;
      state.wasCompleted = false;
      state.wasLevelStarted = false;
      state.isPaused = false;
      state.gameActiveStartTime = null;
      state.levelTime = {};
      state.gameTotalDuration = 0;
      state.levelTotalDuration = {};
      state.gamePageCurrentURL = gamePageCurrentURL;
    },
  },
  selectors: {
    idSelector: (state) => state.id,
    genreSelector: (state) => state.genre,
    subjectSelector: (state) => state.subject,
    themeSelector: (state) => state.theme,
    categorySelector: (state) => state.category,
    fullnameSelector: (state) => state.fullname,
    wasStartedSelector: (state) => state.wasStarted,
    wasCompletedSelector: (state) => state.wasCompleted,
    wasLevelStartedSelector: (state) => state.wasLevelStarted,
    isPausedSelector: (state) => state.isPaused,
    gameActiveStartTimeSelector: (state) => state.gameActiveStartTime,
    levelTimeSelector: (state) => state.levelTime,
    gameTotalDurationSelector: (state) => state.gameTotalDuration,
    levelTotalDurationSelector: (state) => state.levelTotalDuration,
    gameHasCompletionStateSelector: (state) => state.gameHasCompletionState,
    gamePageCurrentURLSelector: (state) => state.gamePageCurrentURL,
  },
});

export const {
  idSelector,
  genreSelector,
  subjectSelector,
  themeSelector,
  categorySelector,
  fullnameSelector,
  wasStartedSelector,
  wasCompletedSelector,
  wasLevelStartedSelector,
  isPausedSelector,
  gameActiveStartTimeSelector,
  levelTimeSelector,
  gameTotalDurationSelector,
  levelTotalDurationSelector,
  gameHasCompletionStateSelector,
  gamePageCurrentURLSelector,
} = gameSlice.selectors;
export const {
  setId,
  setGenre,
  setSubject,
  setTheme,
  setCategory,
  setFullname,
  setWasStarted,
  setWasCompleted,
  setWasLevelStarted,
  setIsPaused,
  setGame,
  setGameActiveStartTime,
  setLevelTime,
  setGameTotalDuration,
  setLevelTotalDuration,
  setGameHasCompletionState,
  setGamePageCurrentURL,
} = gameSlice.actions;

export default gameSlice.reducer;
